import {mustache} from "../handlebars_family.js";
import * as i18n from "../i18n.ts";
import * as blackveil from "../lib/blackveil2.js";
import TPL from "../widget/action-menu.mustache";
import TPL_selected from "../widget/action-menu-selected.mustache";
import $ from "../$.js";
import { MonthDatePicker } from "../calendar/MonthDatePicker.ts";
import { TEMPLATE } from "../TEMPLATE.ts";
import Icons from "../svg/Icons.ts";
import { getData } from "./action-menu-registry.ts";

function init(o){
  var 
    subInput = o.find('input'),
    menu,
    isLarge = o.hasClass('large')||o.width()>100;
    
  if(o.attr('data-type')==='select'){
    
    var displayNodes;
    async function majUI(){
      (await getData(o)).menu.forEach(function(option){
        if(option.value===subInput.val()){
          if(displayNodes){
            displayNodes = Html.replaceWith(displayNodes,TPL_selected,option)
          }else{
            displayNodes = Html.setHtmlAtStart(o,TPL_selected,option)
          }
        }
      })
        
    }
    subInput.on('change',majUI);
    majUI();
  }  
  o.on('click',function(event){
    event.preventDefault();
    event.stopPropagation();
    if(menu!==undefined){
      close()
    }else{
      open(event);
    }
  })
  o.on('open',function(event){
    if(menu===undefined){
      open(event);
    }
  })
  
  async function refreshButtonFromData(index){
    var 
      datas = await getData(o),
      selected = index===undefined?(datas.menu.filter(menu=>menu.selected)[0] || datas.menu[0]):datas.menu[index],
      html = (TEMPLATE`
${selected.svg?TEMPLATE`<icon class="${selected.iconclass}">${selected.svg}</icon>`:''}
${selected.emoji?TEMPLATE`<emoji class="${selected.iconclass}">${selected.emoji}</emoji>`:''}
<line class="flexauto">${selected.title}${i18n.get(selected.i18nkey)}</line>
<icon class="rotateable">${Icons.ic_chevron_down}</icon>`)
    
    o.html(html.toString())
  }

  //TODO merge this with data-type=select
  if(o.attr('data-autofill')==='true'){
    refreshButtonFromData()
  }
  async function open(event,forcedDatas){
    var 
      datas = forcedDatas?forcedDatas:await getData(o),
      overflowRoot = null,
      zRoot = o.parent(),
      
      scrollY = zRoot.get(0).scrollTop,
      scrollX = zRoot.get(0).scrollLeft;
    
    if(datas.menu && datas.menu.length===1){
      var menu0 = datas.menu[0];
      if(menu0.submenu){
        datas = {menu:menu0.submenu}
      }
    }
    
    //calculate position
    while(['absolute','fixed','relative'].indexOf(zRoot.css('position'))===-1){
      zRoot = zRoot.parent();
      scrollY += zRoot.get(0).scrollTop;
      scrollX += zRoot.get(0).scrollLeft;
      if(zRoot.css('overflow')==='overlay' && overflowRoot===undefined){
        overflowRoot = zRoot;
      }
    }
    
    if(!overflowRoot) overflowRoot = zRoot;
    var 
      rectActionMenu = o.get(0).getBoundingClientRect(),
      rect = overflowRoot.get(0).getBoundingClientRect(),
      openOnLeft = ( (rectActionMenu.left+rectActionMenu.right)/2<(rect.left+rect.right)/2 );
    
      if(datas.position==='parent'){
        var
          objRect = o.parent().get(0).getClientRects()[0],
          rootRect = zRoot.get(0).getClientRects()[0];
        datas.css = {
          'width':'100%'
        }
        //FIXME review those 0, it works for recipeCategorie filter but elsewhere?
        datas.css.top = "0";
        datas.css.left = "0";
        datas.css.margin='0 !important'
      }else{
        datas.isLarge = isLarge
        
        var
          objRect = o.get(0).getClientRects()[0],
          rootRect = zRoot.get(0).getClientRects()[0],
          transformOrigin = []
        datas.css = {
          'min-width':objRect.width+'px'
        };
        if(event.clientY===undefined || event.clientY<0.7*window.innerHeight){
          datas.css.top = (objRect.top-rootRect.top+objRect.height+scrollY)+"px";
          transformOrigin.push('top')
        }else{
          datas.css.bottom = (rootRect.bottom-objRect.bottom+objRect.height-scrollY)+"px";
          transformOrigin.push('bottom')
        }
        if(!(datas.position==='right') && openOnLeft){
          datas.css.left = (objRect.left-rootRect.left+scrollX)+"px";
          transformOrigin.push('left')
        }else{
          datas.css.right = (rootRect.right-objRect.right-scrollX)+"px";
          transformOrigin.push('right')
        }
        datas.css['transform-origin'] = transformOrigin.join(' ');
      }  
    
    o.get(0).insertAdjacentHTML('afterEnd',mustache(TPL,datas)); 
    menu = o.get(0).nextSibling;
    setTimeout(()=>{
      var rect = menu.getBoundingClientRect()
      if(rect.x<0){
        menu.style.right = (parseFloat(menu.style.right)+rect.x)+'px'
      }
    },10)

    if(datas.pickdate){
      var datePickerNode = menu.querySelector(".MonthDatePicker") 
      new MonthDatePicker(datePickerNode,{
        date:datas.pickdate.date,
        firstDayOfWeek : datas.pickdate.firstDayOfWeek,
        showWeek:false,
        onpickdate(date){
          close()
          datas.pickdate.onpickdate(date) 
        }
      })
    }
  

    blackveil.show(o).on('click',function(){
      if(datas.onCancel){
        datas.onCancel()
      }
      close()
    });
    $(menu).on('click','div[data-fw-onclick!=togglemenu]',close);
    $(menu).on('click','div[data-menu-index]',function(){
      //FIXME make it work for submenu
      var index = this.getAttribute('data-menu-index');
      datas.menu[index].clickFunction()
    });
    //TODO merge this with data-type=select
    if(o.attr('data-autofill')==='true'){
      menu.addEventListener('click',function(event){
        var node = event.target.closest('div');
        if(node.parentNode===menu && node.classList.contains('fillMenu')){
          var indexInDom = 0, crawler = node;
          while((crawler=crawler.previousSibling)!=null){
            if(crawler instanceof HTMLElement){
              indexInDom ++;
            }
          }
          refreshButtonFromData(indexInDom)
        }
      });
    }
    
    $(menu).on('click','.emoji-picker emoji',function(evt){
      var value = $(evt.target).html();
      if(o.find('input').length){
        o.find('emoji').html(value)
        o.find('input').val(value).trigger('change')
      }else{
        var targetNode = o.closest("form").find('textarea,*[name="text"]');
        targetNode.val( targetNode.val() + value );
        targetNode.focus();
      }
    })
    $(menu).css('display','block')
    $(menu).find('.selected').each((idx,domNode)=>{
      domNode.scrollIntoView({/* behavior: 'smooth',*/ block: 'nearest', inline: 'center' });
    })
    
     o.find('.rotateable').css('transform','rotateZ(180deg)')
    
  }
  function close(){
    o.css('z-index','undefined');
    blackveil.hide(o);
    $(menu).css('transform',isLarge?'scaleY(0)':'scale(0)')
    o.find('.rotateable').css('transform','unset')
    
    setTimeout(function(){
      //500ms later the menu might have been removed
      if(menu.parentNode){
        menu.parentNode.removeChild(menu); 
      }
      menu = undefined;
    },500)
  }
  return {open,close}
}
Html.registerWidget("widget/action-menu",{init:init})
export {init}